/**
 * HitMarker Component
 *
 * Visual indicator for a successful hit on the grid.
 * Displays a distinctive red X symbol with animation.
 *
 * Props:
 * - size: Size variant (small, medium, large)
 * - className: Custom CSS classes
 */

export default function HitMarker({ size = 'medium', className = '' }) {
  // Size mappings with descriptive class names for testing
  const sizeClasses = {
    small: 'text-sm small',
    medium: 'text-2xl',
    large: 'text-4xl large',
  };

  const textSize = sizeClasses[size] || sizeClasses.medium;

  return (
    <div
      data-testid="hit-marker"
      role="img"
      aria-label="Hit"
      className={`flex items-center justify-center text-red-500 font-bold transition-all duration-200 ${textSize} ${className}`}
    >
      ×
    </div>
  );
}
